import axios from "axios";
import { FormikValues } from "formik";
import { AppDispatch, RootState } from "../../app/store";
import { texts } from "../../components/TermsOfServicePage/i18n";
import { onUpdateCompletedForm } from "../../reducers/onboardingDataReducer";
import investmentProfileStep from "../../steps/interactiveBrokers/investmentProfileStep";
import personalInformationStep from "../../steps/interactiveBrokers/personalInformationStep";
import tokenStep from "../../steps/interactiveBrokers/tokenStep";
import { Option, PitbullCountry, Template } from "../../types";
import { getCompanyData, getCountries } from "../../utils";

const onboardingInteractiveBrokers = async ({
  state,
}: {
  values: FormikValues;
  dispatch: AppDispatch;
  state: RootState;
}) => {
  const { favicon, formTitle, logo } = getCompanyData();

  const { language = "es" } = state.onboardingData;
  const { riskProfileQuestionnaire } = state.interactiveBrokers;
  const referralOptions = state.interactiveBrokers.promoters.map(
    ({ id, name }) => ({ value: id.toString(), label: name })
  );

  const [countries] = await axios.all([getCountries()]);
  const countriesTyped = countries as PitbullCountry[];
  const countriesOptions: Option[] = countriesTyped?.map(({ name }) => {
    return { value: name, label: name };
  });

  // Fake step to show TOS as fourth step on stepper. This is necessary because
  // TOS is not an actual step, it has its own page and component.
  // The fake step gets skipped on `investmentProfileStep`'s last `onContinue`
  const fakeTosStep = { step: 4, name: texts[language].stepperTitle };

  const template: Template = {
    favicon,
    formTitle,
    logo,
    onboardingType: "INTERACTIVE_BROKERS",
    preconfirmation: null,
    steps: [
      tokenStep({ language }),
      personalInformationStep({ language, countriesOptions, referralOptions }),
      investmentProfileStep({
        riskProfileQuestionnaire: riskProfileQuestionnaire ?? undefined,
        language,
      }),
      fakeTosStep,
    ],
    onTemplateCompleted: ({ navigate, dispatch }) => {
      dispatch(onUpdateCompletedForm(true));
      navigate("/terminos-y-condiciones");
    },
  };

  return template;
};

export default onboardingInteractiveBrokers;
